import { fetchDataV2 } from "./utils";

export interface ExternalAppToken {
  token: string;
  user_token: string;
}

export const getVisitToLeadToolToken = (): Promise<ExternalAppToken> => fetchDataV2("/externalapp/get-external-app-token");
